/* eslint-disable */
import React from 'react';
import { connect } from "react-redux";
import ImageMapper from '../ImageMapper/imageMapper'
import './trackSNPdistance.css';
import {
    Col,
    Row,
    UncontrolledTooltip
} from 'reactstrap'
import zoomInIcon from '../../assets/zoom-in.svg'
import zoomOutIcon from '../../assets/zoom-out.svg'
import unknownLocation from '../../assets/unknown_location.png';
import SampleSNPDistance from '../SNPDistanceSampleDisplay/SNPDistanceSampleDisplay'
import { fetchSNPTrackingData } from '../../actions';
const initialState = {
    name: "floor-map",
    width: 0,
    height: 0,
    clickedFloorArea: undefined,
    zoomInEnabled: true,
    zoomOutEnabled: true
}

class TrackSnpDistance extends React.Component {
    constructor(props) {
        super(props);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.state = initialState
        if (props.resultsData.locations_data !== 'undefined' && props.resultsData.locations_data.data !== undefined && props.resultsData.locations_data.data.length > 0) {
            this.fetchLocationAreas(props.resultsData.locations_data)
        }

        this.floorElement = element => {
            if (element) {
                let floorDim = element.container.getBoundingClientRect()
                this.setState({
                    leftFloor: floorDim.left,
                    topFloor: floorDim.top,
                });
            }
        };

    }
    componentWillMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }
    updateWindowDimensions() {
        let width = window.innerWidth > 1114 ? window.innerWidth * 0.75 : window.innerWidth * 0.66
        this.setState({ width: 865, height: 550, zoomOutEnabled: false, zoomInEnabled: width<2000?true:false});
    }

    clicked = (area) => {
        this.setState({
            roomName: area.name,
            clickedFloorArea: area,
        })
    }

    getTipPosition(area) {
        if (area && area.locationObject) {
            let typeOfArea = 'Floor'
            let style = { top: `${this.state['top' + typeOfArea] + area.center[1]}px`, left: `${this.state['left' + typeOfArea] + area.center[0] - this.state.width * 0.075}px` }

            return style;
        }
    }

    getLinesMapping = (trackingLinesdata, sampleDetails) => {
        let trackingAreas = []
        for (let i = 0; i < this.props.barcodePairs.length; i++) {
            let barcode = this.props.barcodePairs[i]
            let all_SNPDistances = sampleDetails[barcode[0]]
            let snpDistance = all_SNPDistances[barcode[1]]
            let coords = trackingLinesdata[barcode[0]].concat(trackingLinesdata[barcode[1]])
            let color
            if(this.props.groups){
                color = snpDistance<=this.props.groups[0]?"#375f78":(snpDistance<=this.props.groups[1]?"#5fb3d4":"#82c3da")
            }
            else {
                    color = '#b734eb'
                }
            trackingAreas.push({ shape: "line", coords: coords, type: 'SNP_result_tracking', strokeColor: color, preFillColor: color, text: snpDistance });

        }
        return trackingAreas
    }


    getSNPResultMapping = (barcode_list, coords, locationObject, sample_areas, trackingLinesdata, sampleDetails) => {
        if (coords.length > 4) {
            coords = locationObject.rect_coordinates.split(",").map(Number)
        }

        let [x1, x2] = coords[0] < coords[2] ? [coords[0], coords[2]] : [coords[2], coords[0]]
        let y1 = coords[1] < coords[3] ? coords[1] : coords[3]
        let width = x2 - x1

        let len = 10 //length of the square
        let mar = 30 //margin between the squares
        let samples_width = ~~(width / (len + mar)) - 1
        let Pairs = [...this.props.barcodePairs]
        barcode_list.forEach((barcode, i) => {
            let horiz_count = ~~(i % samples_width) // nth sample position horizontally in location
            let vert_count = ~~(i / samples_width) //  nth sample position vertically in location
            let coordinates
            let sample_data = []
            Pairs.forEach((item, index) => {
                let snpDistance, color
                if (item[0] === barcode.sample__barcode) {
                    let locationtwo
                    locationtwo = this.props.SNPreaultData.data.filter((data) => {
                        if (item[1] === data.sample.barcode) {
                            return data.sample.location.location_id
                        }
                        return false
                    })
                    snpDistance = locationtwo[0].analysis_result_data[item[0]] 
                    if(this.props.groups){
                        color = snpDistance<=this.props.groups[0]?"#375f78":(snpDistance<=this.props.groups[1]?"#5fb3d4":"#82c3da")
                    }
                    else {
                            color = '#b734eb'
                        }
                    sample_data.push({ barcodeOne: item[0], locationone: locationObject.location_id, barcodetwo: item[1], locationtwo: locationtwo[0].sample.location.location_id, snpDistance:snpDistance, color:color })
                    delete Pairs[index]
                }
                else if (item[1] === barcode.sample__barcode) {
                    let locationone
                    locationone = this.props.SNPreaultData.data.filter((data) => {
                        if (item[0] === data.sample.barcode) {
                            return data.sample.location.location_id
                        }
                        return false
                    })
                    snpDistance = locationone[0].analysis_result_data[item[1]] 
                    if(this.props.groups){
                        color = snpDistance<=this.props.groups[0]?"#375f78":(snpDistance<=this.props.groups[1]?"#5fb3d4":"#82c3da")
                    }
                    else {
                            color = '#b734eb'
                        }
                    sample_data.push({ barcodeOne: item[1], locationone: locationObject.location_id, barcodetwo: item[0], locationtwo: locationone[0].sample.location.location_id, snpDistance: snpDistance, color: color })
                    delete Pairs[index]
                }
            })


            coordinates = [x1 + mar * (horiz_count + 1) + len * horiz_count, y1 + mar * (vert_count + 1) + len * vert_count, x1 + mar * (horiz_count + 1) + len * (horiz_count + 1), y1 + mar * (vert_count + 1) + len * (vert_count + 1)]
            sample_areas.push({ shape: "rect", coords: coordinates, preFillColor: "#3a09ed", barcode: barcode, type: 'SNP_result_tracking', locationObject: locationObject, sample_data: sample_data })
            if (trackingLinesdata.hasOwnProperty(barcode.sample__barcode)) {
                trackingLinesdata[barcode.sample__barcode].push(coordinates[0] + len / 2, coordinates[1] + len / 2)
                sampleDetails[barcode.sample__barcode] = barcode.analysis_result_data
            }
        })
        return [sample_areas, trackingLinesdata, sampleDetails]
    }
    getLocationMapping = (locationData) => {
        let areas = []
        let sampleMappingAreas = []
        let trackingLinesdata = {}
        let sampleDetails = {}
        this.props.selectedbarcodes.forEach((barcode) => {
            trackingLinesdata[barcode] = []
            sampleDetails[barcode] = []
        })

        let [floor_map, floor_name, building_name, floor_plan_width] = ''

        let floor_data = locationData.floor_data

        floor_map = floor_data.floor_plan
        floor_name = floor_data.floor_name
        floor_plan_width = floor_data.floor_plan_width
        building_name = floor_data.building.building_name

        let locationMapData = locationData.data
        locationMapData.forEach((locationObject, i) => {
            let coords = locationObject.coordinates.split(",").map(Number)
            let barcode_list = locationObject.barcode
            let shape = ""
            let sample_areas = []
            if (coords.length > 4) {
                shape = "poly"
            }
            else {
                shape = "room"
            }
            if (barcode_list.length > 0) {
                let data = this.getSNPResultMapping(barcode_list, coords, locationObject, sample_areas, trackingLinesdata, sampleDetails)
                sample_areas = data[0]
                trackingLinesdata = data[1]
                sampleDetails = data[2]

            }
            areas.push({ name: locationObject.room.room_name, sample_areas: sample_areas, shape: shape, coords: coords, locationObject: locationObject, type: 'SNP_result_tracking', strokeColor: '#9398c7', preFillColor: "#f1f2f869",fillColor: "#ebfcfc", clickedFillColor: "#dfe2f780", clickedStrokeColor: '#143d8d',  text: locationObject.room.room_name });
            sampleMappingAreas.push(...sample_areas)
            areas.push(...sample_areas)
        });
        let trackingAreas = this.getLinesMapping(trackingLinesdata, sampleDetails)
        areas.push(...trackingAreas)
        areas.push(...sampleMappingAreas)

        return [areas, floor_map, floor_name,floor_plan_width, building_name]
    }

    fetchLocationAreas = (locations_data) => {
        let [areas, floor_plan, floor_name,floor_plan_width, building_name] = this.getLocationMapping(locations_data)
        this.state = {
            name: "floor-map",
            width: 0,
            height: 0,
            areas: [...areas],
            floor_plan: floor_plan,
            floor_name: floor_name,
            floor_plan_width: floor_plan_width,
            building_name: building_name,
            key: 1,
            clickedFloorArea: undefined,
        }
    }

    zoomIn = () => {
        let width = this.state.width
        if (width < 2000) {
            width = width + ((2 / 100) * width)
            this.setState({ width: width, zoomOutEnabled: true, zoomInEnabled: width<2000?true:false})
        
            //To increase each coordinate value to keep the mapping in place
            if(!localStorage.getItem('guest') && !localStorage.getItem('species')){
                this.state.areas.forEach((item, index) =>{
                    let new_coords = []
                    let new_item 
                    item['coords'].forEach((item) => {
                        new_item = item + ((2 / 100) * item)
                        new_coords.push(new_item)
                    })
                    this.state.areas[index]['coords'] = new_coords
                    let new_areas = this.state.areas
                    new_areas.coords = new_coords
                })
                this.setState({areas : this.state.areas})
            }
        }
    }
    zoomOut = () => {
        let actualwidth = window.innerWidth > 1114 ? window.innerWidth * 0.75 : window.innerWidth * 0.66
        let width = this.state.width
        if (width > actualwidth) {
            width = width - ((2 / 100) * width)
            this.setState({ width: width, zoomInEnabled: true, zoomOutEnabled: width > actualwidth})
        
            //To decrease each coordinate value to keep the mapping in place
            if(!localStorage.getItem('guest') && !localStorage.getItem('species')){
                this.state.areas.forEach((item, index) =>{
                    let new_coords = []
                    let new_item 
                    item['coords'].forEach((item) => {
                        new_item = item - ((2 / 100) * item)
                        new_coords.push(new_item)
                    })
                    this.state.areas[index]['coords'] = new_coords
                    let new_areas = this.state.areas
                    new_areas.coords = new_coords
                })
                this.setState({areas : this.state.areas})
            }
        }
    }


    render() {
        return (
            <div >
                <div>
                    {this.state.clickedFloorArea ?

                        <SampleSNPDistance roomDetails={this.state.clickedFloorArea} roomName={this.state.roomName}></SampleSNPDistance>
                        :
                        null
                    }
                    <Row className="d-flex justify-content-end">
                        <Col sm={1} md={1} lg={1} className="zoom-borders">
                            <div className={"border-icons border-icons-left"+(this.state.zoomInEnabled?"":" border-icons-disable")} id="ZoomIn" onClick={this.zoomIn} >
                                <img id="ZoomIn" src={zoomInIcon} alt=''/>
                                <UncontrolledTooltip placement="top" target="ZoomIn">
                                    Zoom In
                                </UncontrolledTooltip>
                            </div>
                            <div className={"border-icons border-icons-right"+(this.state.zoomOutEnabled?"":" border-icons-disable")} id="ZoomOut" onClick={this.zoomOut}>
                                <img src={zoomOutIcon} alt=''/>
                                <UncontrolledTooltip placement="top" target="ZoomOut">
                                    Zoom Out
                                    </UncontrolledTooltip>
                            </div>
                        </Col>
                    </Row>
                    {this.state.areas && this.state.floor_plan ?
                    <>
                        <Row>
                            {this.state.areas.some(area=>area.text === "Unknown Room")?
                                <Col sm={4} md={3} lg={3} xl={2}>
                                    <div>
                                        <img className="right-align-unknown-room" src={unknownLocation} alt='' title="Unknown room"/>
                                    </div>
                                </Col>
                            :null}
                        </Row>
                        <Row>
                            <Col className="center-align floorplan-overflow">
                                <ImageMapper
                                    ref={this.floorElement}
                                    id='map'
                                    src={this.state.floor_plan}
                                    key={'floorplan' + this.props.key}
                                    map={{ name: this.state.name, areas: this.state.areas }}
                                    imgWidth={this.state.floor_plan_width}
                                    width={this.state.width}
                                    onClick={area => this.clicked(area)}
                                    currentlyClickedArea={this.state.clickedFloorArea}
                                />
                            </Col>
                        </Row>
                    </>
                    : null}
                </div>
                {this.state.hoveredType ? <div className="tooltips"
                    style={{ ...this.getTipPosition(this.state.hoveredArea) }}>{this.state.hoveredName}
                </div> : null}
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        locationData: state.location_data.locationData,
    }
}

export default connect(
    mapStateToProps,
    {
        fetchSNPTrackingData
    }
)(TrackSnpDistance)